import * as Validators from "src/utils/validators";
import { isCheckToThousand } from "src/utils/validators";
import { ERROR_TYPE } from "./constants";
import {
    HUMANIZED_TYPES,
    LOAN_TYPES,
    HUMANIZED_OBJECTIVES,
} from "src/redux/Tx/constants";
import { ROLE } from "src/redux/TopBar/constants";
import { ConfirmationSelectors } from "src/redux/Confirmations/selectors";
import { store } from "src/index";
import {
    CONFIRM_EDIT_MODE,
    HUMANIZED_TX_TYPES,
} from "src/redux/Confirmations/constants";
import {
    confirmationErrorType,
    confirmationOriginValue,
} from "src/components/views/Confirmations/List/Table/column_defs";
import { getFromLocalUserStorage } from "src/utils/localStorage";
import { Tx } from "src/redux/Tx/types";
import empty from "is-empty";
import { isTxQtyComparable } from "src/components/views/Transactions/List/Table/column_defs";
import { TxSelectors } from "src/redux/Tx/selectors";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import { FETCH_STATES } from "src/redux/Tx/constants";

export const txSplitOfferTooltipGetter = (params) => {
    const id = params.node.key || params.data?.id;

    const { isSplitAllowed, error } = TxSelectors.IsSplitOfferAllowed(
        store.getState(),
        id
    );

    if (isSplitAllowed) return null;
    return {
        errorType: error,
    };
};

export const qtyToolTipGetter = (params) => {
    if (!params.data) return null;
    const { value, allowZero } = params.value;
    if (Number(value) === 0 && allowZero) return null;

    if (isNaN(value) || value <= 0 || value > Validators.TRU_MAX_QUANTITY) {
        return { errorType: ERROR_TYPE.QTY, allowZero };
    }

    if (!isCheckToThousand(params.data.Country, value)) {
        return { errorType: ERROR_TYPE.QTY_TW };
    }
};

// preview page offer qty
export const offerQtyToolTipGetter = (params) => {
    let qtyError = qtyToolTipGetter(params);
    if (!empty(qtyError)) return qtyError;

    const { value, listName, securityId, ISIN } = params.value;
    if (value && !empty(listName)) {
        let isDynamicOrClientPoolList =
            Validators.isDynamicOrClientPoolList(listName);

        // combined check first to make all rows consistently show the same tooltip,
        // and if offer qty == inv qty for this row the individual error is misleading.
        // BUG: ISIN provided instead of securityId as rows contain ISIN in the 'securityId' column
        // by mistake
        if (
            TxSelectors.CountOfListSecurityCreateRows(
                store.getState(),
                params.data?.ListName,
                params.data?.SecurityId
            ) > 1
        ) {
            let totalOffered = TxSelectors.CreateRowDataTxTotalOfferedQty(
                store.getState(),
                listName,
                ISIN
            );
            if (
                !Validators.isTxQuantityBelowInventoryQty(
                    listName,
                    isDynamicOrClientPoolList,
                    totalOffered,
                    securityId,
                    params.context.role
                )
            ) {
                if (isDynamicOrClientPoolList) {
                    return {
                        errorType:
                            ERROR_TYPE.COMBINED_QTY_EXCEEDS_DYNAMIC_LIST_INVENTORY,
                    };
                } else {
                    return {
                        tooltipMessage: "Combined Offer Qty exceeds Tru Qty",
                    };
                }
            }
        }

        if (
            !Validators.isTxQuantityBelowInventoryQty(
                listName,
                isDynamicOrClientPoolList,
                value,
                securityId,
                params.context.role
            )
        ) {
            if (isDynamicOrClientPoolList) {
                return {
                    errorType: ERROR_TYPE.QTY_EXCEEDS_DYNAMIC_LIST_INVENTORY,
                };
            } else {
                return {
                    tooltipMessage: "Offer Qty exceeds Tru Qty",
                };
            }
        }
    }

    return null;
};

export const rateTooltipGetter = (params) => {
    if (!params.data) return null;
    const { value } = params.value;
    if (!Validators.isRateValid(value)) {
        return { errorType: ERROR_TYPE.RATE };
    }
};

export const availableRateTooltipGetter = (params) => {
    if (!params.value.value) return null;
    return rateTooltipGetter(params);
};

export const divTooltipGetter = (params) => {
    if (!params.colDef.editable(params)) return null;
    if (!Validators.isDividendValid(params.value.value, true)) {
        return { errorType: ERROR_TYPE.DIV };
    }

    if (params.data.IsPartnerTrade) {
        let requestDividendRate = params.data?.OriginValue?.Dividend;
        if (requestDividendRate === undefined) return null;

        let requestDividendIndicator =
            params.data?.OriginValue?.DividendIndicator;

        let dividend = params.value.value;

        if (requestDividendIndicator === true) {
            if (dividend > requestDividendRate) {
                return {
                    errorType: ERROR_TYPE.DIVIDEND_EXCEEDS_REQUESTED,
                    originValue: requestDividendRate,
                };
            }
        } else {
            if (dividend !== requestDividendRate) {
                return {
                    errorType: ERROR_TYPE.DIVIDEND_NOT_EXACT_MATCH,
                    originValue: requestDividendRate,
                };
            }
        }
    }

    return null;
};

export const callableTooltipGetter = (params) => {
    if (!params.colDef.editable(params)) return null;

    if (params.data.IsPartnerTrade) {
        let requestCallable = params.data?.OriginValue?.Callable;

        let callable = params.value.value;

        if (callable !== requestCallable) {
            return {
                errorType: ERROR_TYPE.CALLABLE_INCOMPATIBLE,
                originValue: requestCallable ? "Y" : "N",
            };
        }
    }

    return null;
};

export const availableQtyTooltipGetter = (params) => {
    if (!params.data) return null;
    if (params.value < params.data.Quantity) {
        return {
            tooltipMessage: "Request Qty is greater than Available Qty",
            testId: "tooltip-available-rate",
        };
    }
    return null;
};

export const txCollateralTooltipGetter = (params) => {
    if (!params.data) return null;

    if (
        !Validators.isOfferCollTypeCompatibleWithRequestCollType(
            params.data.IsPartnerTrade,
            params.data.CollateralType,
            params.data.OriginValue.CollateralType
        )
    ) {
        return {
            errorType: ERROR_TYPE.QTY_MISMATCH_COLLATERAL,
            originValue: params.data.OriginValue.CollateralType,
        };
    }

    return null;
};

export const txCurrencyTooltipGetter = (params) => {
    if (!params.data) return null;

    if (
        !Validators.isOfferCollCcyCompatibleWithRequestCollCcy(
            params.data.IsPartnerTrade,
            params.data.CollateralCCY,
            params.data.OriginValue.CollateralCCY
        )
    ) {
        return {
            errorType: ERROR_TYPE.QTY_MISMATCH_CURRENCY,
            originValue: params.data.OriginValue.CollateralCCY,
        };
    }

    return null;
};

// transactions page offer qty
export const txQtyTooltipGetter = (params) => {
    if (!params.data) return null;
    const { value } = params.value;
    if (params.colDef.editable && !params.colDef.editable(params)) {
        if (
            !isTxQtyComparable(
                params.data.Status,
                params.data.Type,
                params.data.MyRole
            )
        )
            return null;
        if (!isNaN(parseInt(params.data.RemainingQuantity))) {
            return {
                tooltipMessage: `Qty ${
                    value <= params.data.RemainingQuantity ? "" : "Not "
                }Sufficient`,
                testId: "tooltip-tx-qty",
            };
        } else {
            return null;
        }
    }

    // truQty is not editable but we use the associated offer qty to check limits
    if (
        params.type === "txListTruQty" ||
        (params.colDef.editable && params.colDef.editable(params))
    ) {
        if (isNaN(value) || value <= 0 || value > Validators.TRU_MAX_QUANTITY) {
            if (params.type === "txListTruQty") return null;
            // already part of offer column error
            else
                return {
                    errorType: ERROR_TYPE.QTY,
                };
        }

        if (!isCheckToThousand(params.data.Country, value)) {
            if (params.type === "txListTruQty") return null;
            // already part of offer column error
            else
                return {
                    errorType: ERROR_TYPE.QTY_TW,
                };
        }

        if (params.data.Type === LOAN_TYPES.HOLD) {
            const { OriginOfferQuantity } = params.data.OriginValue;
            const { ReqQuantity } = params.data;

            if (value > ReqQuantity) {
                if (params.type === "txListTruQty") return null;
                // already part of offer column error
                else
                    return {
                        originValue: OriginOfferQuantity,
                        errorType: ERROR_TYPE.QTY_COMPARE_REQ,
                    };
            }

            if (value > OriginOfferQuantity) {
                if (params.type === "txListTruQty") return null;
                // already part of offer column error
                else
                    return {
                        originValue: OriginOfferQuantity,
                        errorType: ERROR_TYPE.QTY_COMPARE_OFFER,
                    };
            } else if (value !== OriginOfferQuantity) {
                if (params.type === "txListTruQty") return null;
                // already part of offer column error
                else
                    return {
                        originValue: OriginOfferQuantity,
                    };
            }
        }

        const { "enable-min-increment-quantity": enableMinIncrementQty } =
            SettingsSelectors.FeatureFlags(store.getState());

        let ParentId = params.data.ParentId;
        let offerQuantity =
            ParentId === undefined
                ? params.value.value
                : TxSelectors.TotalOfferForPreloanId(
                      store.getState(),
                      ParentId
                  );

        if (
            !Validators.isPartnerTradeQuantityValid(
                // todo: why do we have so many ways of specifying the role?
                params.context.role === "lending" ? "LENDER" : "BORROWER",
                params.data.ReqQuantity,
                offerQuantity,
                params.data.MinQuantity,
                params.data.IncQuantity,
                enableMinIncrementQty,
                params.data.IsPartnerTrade,
                params.data.Status
            )
        ) {
            return {
                errorType: ERROR_TYPE.QTY_MISMATCH_MIN_MAX_INC,
            };
        }

        if (params.context.role === ROLE.LENDER) {
            const { value } = params.value;

            if (value && !empty(params.data?.ListName)) {
                let isDynamicOrClientPoolList =
                    Validators.isDynamicOrClientPoolList(params.data?.ListName);

                // combined check first to make all rows consistently show the same tooltip,
                // and if offer qty == inv qty for this row the individual error is misleading.
                let countOfRows = TxSelectors.CountOfListSecuritySelectedRows(
                    store.getState(),
                    params.data?.ListName,
                    params.data?.SecurityId
                );
                let isCombinedBelowQty =
                    Validators.isSelectedRowsTxQuantityBelowInventoryQty(
                        store.getState(),
                        params.data?.ListName,
                        isDynamicOrClientPoolList,
                        params.data?.SecurityId,
                        params.context.role
                    );
                if (countOfRows > 1 && !isCombinedBelowQty) {
                    if (isDynamicOrClientPoolList) {
                        return {
                            errorType:
                                ERROR_TYPE.COMBINED_QTY_EXCEEDS_DYNAMIC_LIST_INVENTORY,
                        };
                    } else {
                        return {
                            tooltipMessage:
                                "Combined Offer Qty exceeds Tru Qty",
                        };
                    }
                }

                if (
                    !Validators.isTxQuantityBelowInventoryQty(
                        params.data?.ListName,
                        isDynamicOrClientPoolList,
                        value,
                        params.data?.SecurityId,
                        params.context.role
                    )
                ) {
                    if (isDynamicOrClientPoolList) {
                        return {
                            errorType:
                                ERROR_TYPE.QTY_EXCEEDS_DYNAMIC_LIST_INVENTORY,
                        };
                    } else {
                        return {
                            tooltipMessage: "Offer Qty exceeds Tru Qty",
                        };
                    }
                }
            }
        }
    }

    if (params.data.isPortfolioTrade && value > params.data.ReqQuantity) {
        return {
            tooltipMessage:
                "Offer CU cannot exceed Requested CU for ETF portfolio trades",
        };
    }

    return null;
};

export const txTypeTooltipGetter = (params) => {
    if (!params.data) return null;
    const { value } = params.value;
    const originValue = params.data.OriginType;

    if (value !== originValue) {
        return { originValue: HUMANIZED_TYPES[originValue] };
    }

    return null;
};

export const objectiveTooltipGetter = (params) => {
    if (!params.data) return null;
    const { value } = params.value;
    const originValue = params.data.OriginObjective;

    if (value !== originValue) {
        return { originValue: HUMANIZED_OBJECTIVES[originValue] };
    }

    return null;
};

export const txCreateRateTooltipGetter = (params) => {
    const { value } = params.value;
    if (value && !Validators.isRateValid(value)) {
        return { errorType: ERROR_TYPE.RATE };
    } else if (params.context.role === ROLE.BORROWER) {
        const ac = getFromLocalUserStorage(Tx.AC_STORAGE_VALUE);
        if (!empty(ac)) {
            const rate = parseFloat(value);
            if (isNaN(rate)) {
                return {
                    tooltipMessage: "Any Rate will be automatically confirmed",
                };
            } else {
                const max = rate + ac.maxRateBps / 100;
                return {
                    tooltipMessage: `Auto accepting rate from ${rate.toFixed(
                        2
                    )} till ${max.toFixed(2)}`,
                };
            }
        }
    }
    return null;
};

export const txCreateVDTooltipGetter = (params) => {
    const ac = getFromLocalUserStorage(Tx.AC_STORAGE_VALUE);
    const { value } = params.value;
    if (!empty(ac) && params.context.role === ROLE.BORROWER && !value) {
        return {
            tooltipMessage: "Any Value Date will be automatically confirmed",
        };
    }
    return null;
};

export const confirmationTooltipGetter = (params) => {
    const editMode = ConfirmationSelectors.GetEditMode(store.getState());
    if (editMode !== CONFIRM_EDIT_MODE.ON) return null;
    const error = confirmationErrorType(params);
    const origin = confirmationOriginValue(params);
    if (error || origin) {
        return {
            originValue: origin,
            fieldName: params.colDef.field,
            errorType: error,
        };
    }
    return null;
};

export const marketDataTooltipGetter = (params) => {
    if (!params.data) return null;
    const { data } = params;

    if (params.data?.marketData?.status === FETCH_STATES.ERROR) {
        return {
            tooltipMessage: `Security not found. Either delete this security, or contact KSL support at ops@kslnetwork.com`,
        };
    }

    if (
        Validators.isMarketDataFetched(data.marketData) &&
        !Validators.isAllowedLenderSecurity(
            params.context.role === "lending",
            data.marketData
        )
    ) {
        return {
            tooltipMessage:
                "This security is in the Blocked Security List and cannot be traded.",
        };
    }

    if (params.skipShowingValueDate === true) return null; // we never show V/D on the Security ID column, for example

    if (
        Validators.isMarketDataFetched(data.marketData) &&
        data.marketData.data?.tradableDates
    ) {
        const vdCandidates = data.marketData.data.tradableDates
            .map((date, idx) => `T${idx}: ${date}`)
            .join("\n");

        return {
            tooltipMessage: vdCandidates,
            testId: "tooltip-md",
        };
    }

    return null;
};

export const availabilityLoanTypeTooltipGetter = (params) => {
    if (!params.value) return null;
    const { value } = params.value;
    if (value === LOAN_TYPES.BID) {
        return {
            tooltipMessage:
                "For Bid inbox items the record will not be generated until it is matched through KSFC’s ACE+",
        };
    }

    return null;
};

export const secretButtonTooltipGetter = () => {
    return {
        tooltipMessage:
            "You will need to copy this secret key and provide it to your Lender using a secure method that is in line with your internal security policy.",
    };
};

export const counterpartyCodeTooltipGetter = (data) => {
    return {
        tooltipMessage: data?.value,
    };
};

export const accountNameTooltipGetter = (data) => ({
    tooltipMessage: data?.value,
});

export const listNameTooltipGetter = (params) => {
    const value = params?.value;
    if (!value) return null;
    if (!Validators.isListNameValid(value)) {
        return {
            errorType: ERROR_TYPE.LISTNAME,
        };
    }
    return null;
};

export const txRateTooltipGetter = (params) => {
    if (!params.data) return null;
    const { value } = params.value;
    if (params.colDef.editable && !params.colDef.editable(params)) {
        if (
            !isTxQtyComparable(
                params.data.Status,
                params.data.Type,
                params.data.Role
            )
        )
            return null;
        if (!isNaN(parseFloat(params.data.PreferredRate))) {
            return {
                tooltipMessage: `Rate ${
                    value >= params.data.PreferredRate ? "" : "Not "
                }Sufficient`,
                testId: "tooltip-tx-rate",
            };
        } else {
            return null;
        }
    }
    if (params.colDef.editable && params.colDef.editable(params)) {
        if (!Validators.isRateValid(value)) {
            return {
                errorType: ERROR_TYPE.RATE,
            };
        }
        if (params.data.Type === LOAN_TYPES.HOLD) {
            const { OriginOfferRate } = params.data.OriginValue;
            if (params.data.MyRole === "BORROWER" && value < OriginOfferRate) {
                return {
                    originValue: OriginOfferRate,
                    errorType: ERROR_TYPE.RATE_COMPARE_OFFER,
                };
            }
            if (value !== OriginOfferRate) {
                return {
                    originValue: OriginOfferRate,
                };
            }
        }

        if (
            params.data.IsPartnerTrade &&
            params.data.OriginValue.OriginRequestRate !== undefined
        ) {
            const rate = parseFloat(value);

            if (
                params.data.CollateralType === "NC" ||
                params.data.CollateralType === "CP"
            ) {
                if (rate > params.data.OriginValue.OriginRequestRate) {
                    return {
                        originValue: params.data.OriginValue.OriginRequestRate,
                        errorType: ERROR_TYPE.RATE_TOO_HIGH,
                    };
                }
            } else if (params.data.CollateralType === "CA") {
                if (rate < params.data.OriginValue.OriginRequestRate) {
                    return {
                        originValue: params.data.OriginValue.OriginRequestRate,
                        errorType: ERROR_TYPE.RATE_TOO_LOW,
                    };
                }
            }
        }
    }
    return null;
};

export const genericValueDateTooltipGetter = (params) => {
    if (!params.data) return null;

    if (!params.colDef.editable(params)) return null;

    let isDateValid = Validators.isDateValid(
        params.value?.value?.replace(/-/g, ""),
        params.data?.TradeableDates
    );

    if (!isDateValid) {
        return {
            errorType: ERROR_TYPE.BAD_VALUE_DATE,
        };
    }

    return null;
};

export const valueDateTooltipGetter = (params) => {
    if (!params.data) return null;

    if (!params.colDef.editable(params)) return null;

    let isValueDateValidForPartnerTrade =
        !params.data?.IsPartnerTrade ||
        params.data?.OriginValue?.ValueDate === undefined ||
        // todo: why is this nested??
        params.value?.value === params.data?.OriginValue?.ValueDate;

    let isDateValid = Validators.isDateValid(
        params.value?.value?.replace(/-/g, ""),
        params.data?.TradeableDates
    );

    if (!isDateValid || !isValueDateValidForPartnerTrade) {
        const originValue = params.data.OriginValue[params.type];
        return {
            errorType: ERROR_TYPE.VALUE_DATE_MISMATCH,
            originValue: originValue,
        };
    }

    // just show origin
    if (params.checkOrigin) {
        return TooltipGetterForCompareWithOrigin(params);
    }

    return null;
};

export const maturityTooltipGetter = (params) => {
    if (!params.data) return null;

    if (
        params.colDef.editable(params) &&
        !Validators.isTermValid(params.data.Term)
    ) {
        return {
            errorType: ERROR_TYPE.MATURITY,
        };
    }

    let requestMaturityDate =
        params.data?.OriginValue?.Maturity || "9999-12-31";
    let maturityDate = params.value.value || "9999-12-31";
    let isMaturityDateValidForPartnerTrade =
        !params.data?.IsPartnerTrade || maturityDate === requestMaturityDate;

    if (params.colDef.editable(params) && !isMaturityDateValidForPartnerTrade) {
        return {
            errorType: ERROR_TYPE.MATURITY_DATE_MISMATCH,
            originValue: requestMaturityDate,
        };
    }

    if (params.checkOrigin) {
        return TooltipGetterForCompareWithOrigin(params);
    }

    const { "enable-90-day-max-maturity-date": enable90DayMaxMaturity } =
        SettingsSelectors.FeatureFlags(store.getState());

    if (!Validators.isMaxMaturityValid(params.data, enable90DayMaxMaturity)) {
        return {
            errorType: ERROR_TYPE.MATURITY_MAX_EXCEED,
        };
    }

    return null;
};

export const TooltipGetterForCompareWithOrigin = (params) => {
    if (params.node.level !== 0 || !params.data) return null;
    const originValue = params.data.OriginValue[params.type];
    const { value } = params.value;
    if (params.type === "Callable") {
        if (
            (originValue !== false && empty(originValue)) ||
            originValue === value
        )
            return;
        return { originValue: originValue ? "Y" : "N" };
    } else if (
        originValue &&
        originValue.toUpperCase() !== "ANY" &&
        originValue !== value
    ) {
        return {
            originValue:
                params.type === "TxType"
                    ? HUMANIZED_TX_TYPES[originValue]
                    : originValue,
        };
    }
    return null;
};

export const TooltipGetterShowOriginIfDifferent = (params) => {
    if (params.value?.value !== params.value.OriginValue) {
        const standardized =
            params.type === "GenericValueDate"
                ? params.value.OriginValue.replace(/-/g, "/")
                : params.value.OriginValue;
        return {
            originValue: standardized,
        };
    }

    return null;
};

export const inventoryUploadRowTooltipGetter = (params) => {
    if (!params.data.isReplacing) return null;
    return {
        tooltipMessage: "This record matches an existing inventory record.",
        testId: "tooltip-inventory-replacing-row",
    };
};
